import dayjs from "dayjs";

function stripHTML(html) {
  if (!html) return "";
  var one = html.replace(/<\/?[^>]+(>|$)/gm, "");
  var two = one.replace(/[\r\n]\s*[\r\n]/gm, "");
  return two;
}

function makeJobSchema(job) {
  const desc = stripHTML(job.description);
  return {
    // schema truncated for brevity
    "@context": "http://schema.org",
    "@type": "JobPosting",
    datePosted: job.approved_at,
    description: desc,
    title: job.title,
    image: job.logo_url,
    employmentType: job.job_type,
    jobLocationType: job.job_location_type === "Remote" ? "TELECOMMUTE" : "",
    applicantLocationRequirements: {
      "@type": "Country",
      name: "USA",
    },
    jobLocation:
      job.location && job.job_location_type === "Remote"
        ? {
            "@type": "Place",
            address: {
              "@type": "PostalAddress",
              addressLocality: job.location.split(",").length > 0 ? job.location.split(",")[0] : null,
              addressRegion: job.location.split(",").length > 1 ? job.location.split(",")[1] : null,
              addressCountry: job.location.split(",").length > 2 ? job.location.split(",")[2] : null,
            },
          }
        : null,
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "USD",
      value: {
        "@type": "QuantitativeValue",
        minValue: job.min_salary,
        maxValue: job.max_salary,
        unitText: "YEARLY",
      },
    },
    validThrough: dayjs(job.approved_at).add(30, "days").toISOString(),
    hiringOrganization: {
      "@type": "Organization",
      name: job.company,
      sameAs: job.company || null,
      logo: job.logo_url,
    },
  };
}

export default function JobSchema({ job }) {
  return (
    <script key={`jobJSON-${job.id}`} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(makeJobSchema(job)) }} />
  );
}
